import React from 'react';
import { currentUser } from '../../Utils/Auth';
import { hasPermission } from '../../Utils/Permissions';

export const Guard = ({ permission, fallback = null, children }) => {
  const user = currentUser();
  if (!hasPermission(user, permission)) return fallback;
  return <>{children}</>;
};
